import { render, staticRenderFns } from "./DeliveryTypesList.vue?vue&type=template&id=8cd890fe&"
import script from "./DeliveryTypesList.vue?vue&type=script&lang=js&"
export * from "./DeliveryTypesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports